export default function hasIdWhitelistProp() {
    return {
        idWhitelist: {
            type: Array,
            default: () => [],
        },
    };
}
